import React from 'react'

import { IHomeType, IPageType } from '@/types'
// import { travelBlogPath } from '@/utils'
// import { useLanguages } from '@/hooks'
// import { Link } from '@/i18n'

export const BlogSection: React.FC<IPageType<IHomeType>> = ({ template }) => {
  // const { t } = useLanguages()
  return (
    <section className="blog-section">
      <div className="row">
        <div className="column small-12 medium-6">
          <img
            title=""
            alt="alamo scenic route"
            src="/assets/img/alamo-scenic-route-xf-3.jpg"
          />
        </div>
        <div className="column small-12 medium-6 blog-section-info">
          <h4 className="blog-section-title">{template.blog_title}</h4>
          <p className="description blue-color">{template.blog_description}</p>
          {/* <div className="small-12 medium-6 large-5">
            <Link className="btn btn-purple btn-block" href={travelBlogPath}>
              <span> {t('travelBlogAndNews')} </span>
            </Link>
          </div> */}
        </div>
      </div>
    </section>
  )
}
